export class LoadingIndicator extends HTMLElement {
    static tag = 'loading-indicator';
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        // this.#internals = this.attachInternals();
    }
    connectedCallback() {
        this.shadowRoot.innerHTML = `
      <div class="mark"></div>
      
      <style>
        :host {
          --mark-box-shadow-size: 10px;
          --mark-size: 33%;
        
          overflow: hidden;
          background-color: var(--color-input);
          visibility: hidden;
          display: block;
          height: 6px;
          position: relative;
        }
        
        /*:host(:state(shown)) {*/
        /*  visibility: visible;*/
        /*}*/
      
        :host([shown]) {
          visibility: visible;
        }
        
        .mark {
          width: 33%;
          background-color: red; /*var(--color-main-background);*/
          animation: RunningMark 2s linear infinite;
          height: 100%;
          position: absolute;
          left: calc(-1 * var(--mark-size));;
        }
        
        @keyframes RunningMark {
          0 {
            left: calc(-1 * var(--mark-size));
          }
          
          100% {
            left: calc(100% + var(--mark-size));
          }
        }
      </style>
    `;
    }
    hide() {
        // this.#internals.states.delete('shown');
        this.removeAttribute('shown');
    }
    show() {
        // this.#internals.states.add('shown');
        this.setAttribute('shown', '');
    }
    #internals;
}
customElements.define(LoadingIndicator.tag, LoadingIndicator);
